import React from "react";
import PrivateGuideReservationsDetails from "../../../Components/Organisms/PrivateGuideReservations/Details";

const PrivateGuideReservationsDetailsTemplate = ({ reservationData }) => {
  return <PrivateGuideReservationsDetails reservationData={reservationData} />;
};

export default PrivateGuideReservationsDetailsTemplate;
